import React from "react";
import Dropzone, { type FileRejection } from "react-dropzone";
import { useTranslation } from "react-i18next";
import { Box, Typography } from "@mui/material";
import UpLoadIcon from "assets/icons/upload-icon.svg";

const style = (height: string | undefined) => ({
  flex: 1,
  display: "flex",
  flexDirection: "column",
  justifyContent: "center",
  alignItems: "center",
  height: height || "152px",
  width: "100%",
  borderWidth: 3,
  borderRadius: 8,
  borderColor: "#eeeeee",
  borderStyle: "dashed",
  color: "#bdbdbd",
  outline: "none",
  transition: "border .24s ease-in-out",
  padding: "29px 0px",
  cursor: "pointer",
});

interface OcDropzoneAreaProps {
  onChange: (file: File | File[]) => void;
  onDropRejected?: (fileRejections: FileRejection[]) => void;
  acceptedFiles?: { [key: string]: string[] };
  maxFiles?: number;
  maxSize?: number;
  dropzoneText?: string;
  height?: string;
}

export const OcDropzoneArea: React.FC<OcDropzoneAreaProps> = ({
  onChange,
  onDropRejected,
  acceptedFiles = {
    "image/*": [".png", ".gif", ".jpeg", ".jpg"],
  },
  maxFiles = 1,
  maxSize = 100000000,
  dropzoneText = "",
  height,
}) => {
  const { i18n } = useTranslation();

  let parsedDropzoneText = dropzoneText && dropzoneText.replace("ide", "");
  let hereSpanText = <span style={{ color: "#cc0033" }}>ide</span>;

  if (i18n.language === "en") {
    parsedDropzoneText = dropzoneText && dropzoneText.replace("here", "");
    hereSpanText = <span style={{ color: "#cc0033" }}>here</span>;
  }

  const onDrop = (files: File[]) => {
    if (files.length === 0) {
      return;
    }
    if (maxFiles > 1) {
      onChange(files);
    } else {
      onChange(files[0]);
    }
  };

  const handleDropRejected = (fileRejections: FileRejection[]) => {
    if (onDropRejected) {
      onDropRejected(fileRejections);
    }
  };

  return (
    <Dropzone
      onDrop={onDrop}
      onDropRejected={handleDropRejected}
      accept={acceptedFiles}
      maxFiles={maxFiles}
      maxSize={maxSize}
    >
      {({ getRootProps, getInputProps }) => (
        <Box
          {...getRootProps({ style: style(height) as React.CSSProperties })}
          id="dropzonearea"
        >
          <input {...getInputProps()} />
          <img src={UpLoadIcon} alt="upload" />
          <Typography
            variant="body1"
            color="#919699"
            style={{ marginTop: "16px" }}
          >
            {parsedDropzoneText} {hereSpanText}
          </Typography>
        </Box>
      )}
    </Dropzone>
  );
};

export default OcDropzoneArea;
